import { registerComponent } from '@gig/magic-common';
import ConfirmationPromptComponent from './confirmation-prompt.vue.js';

var ConfirmationPrompt = registerComponent(ConfirmationPromptComponent);

export { ConfirmationPrompt };
